import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ICtoContract, ICtoRetailPlace } from '../../../core/models/cto.model';

@Component({
  selector: 'tax-cto-retail-place',
  templateUrl: './cto-retail-place.component.html',
  styleUrls: ['./cto-retail-place.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class CtoRetailPlaceComponent {
  // @ts-ignore
  @Input() retailPlace: ICtoRetailPlace;
  // @ts-ignore
  @Input() contract: ICtoContract;
  displayKkms: boolean = true;

  constructor() {
  }

  showKkms(): void {
    this.displayKkms = !this.displayKkms;
  }
}
